export default __webpack_public_path__ + "ddcaa1048eca795ff9488aacdedee5ae.jpg";